// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import store from './store/index';
import App from './App';
import router from './router';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/styles/Montserrat_googleapi_font.css';
import './assets/styles/app.scss';
import MaterialDesignIcons from 'material-design-icons-iconfont/dist/material-design-icons.css';
import VueResourceConfig from './vueResourceConfig';
import VeeValidate from 'vee-validate';
import ParleyAdmin from './plugins/ParleyAdmin/parleyAdmin';
import QueryErrors from './util/queryErrors';
import Auth from './util/auth';
import VTooltip from 'v-tooltip';
import BootstrapVue from 'bootstrap-vue';

const config = {
    fieldsBagName: 'fieldsBag', // Default is 'field' which conflicts with 'vue-color' Chrome picker.
    inject: false // Don't inject automatic injection, you have to explicitly inject it into a component (https://baianat.github.io/vee-validate/concepts/injections.html#injecting-parent-validator)
    // This is done because when only using inject '$validator' on 'customInput' comp, it will look for the '$validator' of the parent, but because every comp has a validator it will grab the first parent's validator
    // _and thus this wont work 'this.$validator.errors.add(errorObject)' in this template '<comp1><comp2><customInput/><comp2/><comp1>'
    // _these errors are stored in the '$validator' of 'comp1', but 'customInput' gets the errors from 'comp2' and thus cant show the errors from 'comp1' (example in tfaAppSetup, step 3 'validation')
};

export const eventBus = new Vue();

// Use our custom plugin
Vue.use(ParleyAdmin);

Vue.use(MaterialDesignIcons);

Vue.use(BootstrapVue);

// Set Vue Resource Config
Vue.use(VueResourceConfig);

// Vue input validator
Vue.use(VeeValidate, config);

// Tooltips
Vue.use(VTooltip);

// Http interceptor
Vue.http.interceptors.push((request, next) => {
    if (request.url !== 'v1.1/auth/2fa') // TODO: Fix in API that it should ignore the Authorization header when sent for a function that doesn't need this header
        if (!request.headers.get('Authorization') && store.getters[store.types.token.getters.get_nontemp]) // Only set header if it has not yet been set explicitly
            request.headers.set('Authorization', store.getters[store.types.token.getters.get_nontemp].token); // Always set authorization header
    if (!request.headers.get('x-parley-identification') && store.getters[store.types.loggedinAccount.getters.get].identification) // Only set header if it has not yet been set explicitly
        request.headers.set('x-parley-identification', store.getters[store.types.loggedinAccount.getters.get].identification); // Always set authorization header

    // DEBUG
    if (process.env.NODE_ENV !== "production") {
        request.url += '?XDEBUG_SESSION_START=ADMIN_API';
    }

    // Continue to response
    return async (response) => {
        if (response.status === 200) { // OK
            // IMPORTANT: Saves non-temp only
            // Save token + expire time to storage
            if (response.body.auth) {
                if (response.body.auth.token) // Save the token to the store
                    await store.dispatch(store.types.token.actions.set_nontemp, {token: response.body.auth.token});
                if (response.body.auth.expireTime) // Save the expire time to the store (is it possible that you only get an expire time and not a token if your current token is extended
                    await store.dispatch(store.types.token.actions.set_nontemp, {expireTime: response.body.auth.expireTime});
            }
        } else if (response.status === 400) { // Bad request
            if (response.body.notifications && response.body.notifications.length > 0) {
                if (response.body.notifications.filter((element) => (element.message === 'authorization_not_valid_or_expired' || element.message === 'supplied_token_is_invalid_or_expired')).length > 0)
                    eventBus.$emit('showSessionExpiredModal');
                if (response.body.notifications.filter((element) => element.message.startsWith('you_do_not_have_the_right_to_do_this')).length > 0) {
                    const errorWithRightId = response.body.notifications.filter((element) => element.message.startsWith('you_do_not_have_the_right_to_do_this_rightID_'));
                    const hasRightId = errorWithRightId.length > 0;

                    if (hasRightId) {
                        const errorMessage = response.body.notifications.filter((element) => element.message.startsWith('you_do_not_have_the_right_to_do_this_rightID_'))[0].message;
                        const matches = errorMessage.match(/\d+$/);
                        if (matches && matches.length > 0) {
                            const rightId = matches[0];
                            const rightDescription = Auth.getRightsById([rightId])[0] ? Auth.getRightsById([rightId])[0].description : 'ID ' + rightId;
                            QueryErrors.addError(`You do not have permission to do this action, please contact your administrator.\n\n<small>Permission needed: ${rightDescription}</small>`);
                        } else
                            QueryErrors.addError('You do not have permission to do this action, please contact your administrator');
                    } else
                        QueryErrors.addError('You do not have permission to do this action, please contact your administrator');
                }
            }
        } else if (response.status === 401) { // Unauthorized
            if (response.body.notifications[0].message === 'authorization_not_valid_or_expired')
                eventBus.$emit('showSessionExpiredModal');
        } else if (response.status === 403) // Forbidden
            if (response.body.notifications && response.body.notifications.length > 0) {
                if (response.body.notifications.filter((element) => element.message === 'request_not_allowed').length > 0
                    && process.env.NODE_ENV !== "production") {
                    QueryErrors.addError('Oops, the API call does not exists..');
                }
            }

        return response;
    };
});

Vue.config.productionTip = false; // TODO: What is this???

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {App}
});
